import { BankSource } from '../enum/source/bank-source';
import { BaseDto } from './base.dto';
import { CardDataDto } from './cardData.dto';
import { CustomerPaymentTypeDto } from './customerPaymentType.dto';
import { GiftCardTransactionDto } from './gift-card';
import { MerchantPaymentMethodDto } from './merchantPaymentMethod.dto';
import { OrderDto } from './order.dto';

export class OrderPaymentDto extends BaseDto {
  order: OrderDto;
  customerPaymentMethod: CustomerPaymentTypeDto;
  authorizedAmount: number;
  settledAmount: number;
  success: boolean;
  approvalCode: string;
  message: string;
  data: CardDataDto;
  merchantPaymentMethodId?: number;
  merchantPaymentMethod?: MerchantPaymentMethodDto;
  giftCardTransaction?: GiftCardTransactionDto;
  tenderedAmount?: number;
  changeAmount?: number;
  tipsAmount?: number;
  cashbackAmount?: number;
  additionalAmount?: number;
  fxCurrencyAmount?: number;
  fxCurrencyId?: number;
  fxExchangeRate?: number;
  source?: BankSource;
  stripeConnectWasUsed?: boolean;
  processingFeeAmount?: number;
  splitPaymentCode?: string;
}
